import { render, staticRenderFns } from "./create.vue?vue&type=template&id=a13448d0&scoped=true"
import script from "./create.vue?vue&type=script&lang=js"
export * from "./create.vue?vue&type=script&lang=js"
import style0 from "./create.vue?vue&type=style&index=0&id=a13448d0&prod&lang=less"
import style1 from "./create.vue?vue&type=style&index=1&id=a13448d0&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a13448d0",
  null
  
)

export default component.exports